import * as yup from 'yup';

import { Model as UserModel } from 'models/user/interface';

import { emailRegExp, phoneRegExp } from '../../utils/regExps';
import { endpoint, EndpointError } from '../endpoint';
import { ValidationShape } from '../validation';

export type UpdateParams = UserModel & {
  _id?: UserModel['_id'];
};
export type UpdateResult = { data: UserModel; error?: { message: string } };
export type UpdateError = EndpointError;

const VALIDATION_ERROR = {
  REQUIRED: 'נדרש',
  INVALID_SIZE: 'גודל לא חוקי',
  INVALID_FORMAT: 'פורמט טלפון שגוי',
  REQUIRED_DESCRIPTION: 'חובה להזין תיאור',
  REQUIRED_NAME: 'חובה להזין שם מלא',
  REQUIRED_EMAIL: 'חובה להזין דוא״ל',
  REQUIRED_PHONE: 'חובה להזין טלפון',
  REQUIRED_AVATAR: 'חובה להזין תמונה',
  REQUIRED_ROLE: 'המשתמש חייב להיות בעל תפקיד אחד לפחות',
};

export const updateParamsSchema = yup.object().shape({
  _id: yup.string(),
  name: yup.string().required(VALIDATION_ERROR.REQUIRED_NAME),
  email: yup.string().matches(emailRegExp, VALIDATION_ERROR.INVALID_FORMAT).required(VALIDATION_ERROR.REQUIRED_EMAIL),
  phone: yup.string().matches(phoneRegExp, VALIDATION_ERROR.INVALID_FORMAT).required(VALIDATION_ERROR.REQUIRED_PHONE),
  description: yup.string().required(VALIDATION_ERROR.REQUIRED_DESCRIPTION),
  roles: yup.array(yup.string()).min(1, VALIDATION_ERROR.REQUIRED_ROLE),
  avatarUrl: yup
    .mixed()
    .test('size', VALIDATION_ERROR.INVALID_SIZE, (value) => {
      if (!value || typeof value === 'string') {
        return true;
      }

      if (value && value.size && value.size <= 1024 * 1024 * 1) {
        return true;
      }

      return false;
    })
    .required(VALIDATION_ERROR.REQUIRED_AVATAR),
} as unknown as ValidationShape<UpdateParams>);

export const update = endpoint<UpdateParams, UpdateResult, UpdateError>({
  method: 'POST',
  url: () => `/user`,
});
